import request from '../../utils/request';
import requestFormData from '../../utils/requestFormData';

export function getProviderIntegrations(params) {
  return request(`/provider-integration`, {
    method: 'GET',
    params,
  });
}

export function getProviderIntegration(params) {
  return request(`/provider-integration`, {
    method: 'GET',
    params,
  });
}

export function createProviderIntegration(params) {
  return request(`/provider-integration`, {
    method: 'POST',
    data: params,
  });
}

export function updateProviderIntegration(params) {
  let id;
  try {
    id = params.id || params.get('id');
  } catch (e) {
    // no bother
  }

  // in case it contains an image request with formData
  if (params instanceof FormData) {
    return requestFormData(`/provider-integration/${id}`, {
      method: 'PATCH',
      data: params,
    });
  }
  return request(`/provider-integration/${id}`, {
    method: 'PATCH',
    data: params,
  });
}

export function deleteProviderIntegration(params) {
  const { id } = params;
  return request(`/provider-integration/${id}`, {
    method: 'DELETE',
  });
}
